import { useEffect } from "react";
import { Tabs } from "antd";
import { DataSetter } from "./DataSetter";
import { LiveControlSetter } from "./LiveControlSetter";
import "./SchemaEditors.scss";
import { InfoTooltip } from "../../BaseComps/InfoTooltip";
import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary";
import { observer } from "mobx-react-lite";
import { useMst } from "../../stores/main";
import { CloseOutlined } from "@ant-design/icons";

export const SchemaEditors = observer(() => {
  const {
    layoutStore: { activeSchemaTab, setActiveSchemaTab, setSchemaDrawerOpen },
    platformStore,
  } = useMst();
  const dataTabInfo =
    'Define the structure of the data that is unique to each and every video. e.g - "user_name" and data-base data';
  const hasMultipleTabs = !platformStore.isControlDeprecated;

  useEffect(() => {
    if (
      platformStore.isControlDeprecated &&
      activeSchemaTab === "livecontrol"
    ) {
      setActiveSchemaTab("pervideo");
    }
  }, [platformStore.isControlDeprecated, activeSchemaTab, setActiveSchemaTab]);

  const tabItems = [
    {
      key: "pervideo",
      label: (
        <span>
          <span className={"tab-text"}>Data</span>{" "}
          <InfoTooltip info={dataTabInfo} />
        </span>
      ),
      children: platformStore.projectWorkspaceVersion ? (
        <DataSetter />
      ) : (
        <div></div>
      ),
    },
    ...(hasMultipleTabs
      ? [
          {
            key: "livecontrol",
            label: (
              <span>
                <span className={"tab-text"}>Control</span>{" "}
                <InfoTooltip
                  info={
                    "Define content that can be updated from Blings platform, e.g - call-to-action url, marketing copy, etc"
                  }
                />
              </span>
            ),
            children: platformStore.projectWorkspaceVersion ? (
              <LiveControlSetter />
            ) : (
              <div></div>
            ),
          },
        ]
      : []),
  ];

  return (
    <div className="schema-sidebar">
      <div className="schema-sidebar-header">
        <p className="schema-sidebar-title">
          <span>Dynamic Data</span>
          {!hasMultipleTabs && <InfoTooltip info={dataTabInfo} />}
        </p>
        <button
          className="sidebar-close-button"
          onClick={() => setSchemaDrawerOpen(false)}
          title="Close drawer"
        >
          <CloseOutlined />
        </button>
      </div>

      <ErrorBoundary>
        {hasMultipleTabs ? (
          <Tabs
            activeKey={activeSchemaTab}
            onChange={(key) =>
              setActiveSchemaTab(key as "pervideo" | "livecontrol")
            }
            type="card"
            size={"middle"}
            className="tabs"
            rootClassName="tabs-class"
            items={tabItems}
          />
        ) : (
          <div className="schema-sidebar-single-pane">
            {platformStore.projectWorkspaceVersion ? (
              <DataSetter />
            ) : (
              <div></div>
            )}
          </div>
        )}
      </ErrorBoundary>
    </div>
  );
});
